import React from 'react';

interface PageBackgroundProps {
  className?: string;
}

export function PageBackground({ className = '' }: PageBackgroundProps) {
  return (
    <div className={`fixed inset-0 -z-10 ${className}`}>
      {/* Primary gradients */}
      <div className="absolute inset-0 bg-background-light dark:bg-background-dark" />
      
      {/* Subtle background elements with reduced opacity */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_10%_20%,rgba(37,99,235,0.05),transparent_35%)] dark:bg-[radial-gradient(circle_at_10%_20%,rgba(59,130,246,0.05),transparent_35%)] parallax-element" data-speed="0.05"></div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_70%,rgba(16,185,129,0.05),transparent_35%)] dark:bg-[radial-gradient(circle_at_80%_70%,rgba(52,211,153,0.05),transparent_35%)] parallax-element" data-speed="0.08"></div>
      
      {/* Floating particles with reduced opacity */}
      <div className="absolute left-[10%] top-[15%] w-6 h-6 rounded-full bg-primary-light/15 dark:bg-primary-dark/15 blur-md animate-float-slow" style={{ animationDelay: '0s', animationDuration: '7s' }}></div>
      <div className="absolute left-[25%] top-[40%] w-4 h-4 rounded-full bg-secondary-light/15 dark:bg-secondary-dark/15 blur-md animate-float-slow" style={{ animationDelay: '1.5s', animationDuration: '5s' }}></div>
      <div className="absolute right-[15%] top-[20%] w-5 h-5 rounded-full bg-primary-light/15 dark:bg-primary-dark/15 blur-md animate-float-slow" style={{ animationDelay: '0.7s', animationDuration: '8s' }}></div>
      <div className="absolute right-[35%] top-[65%] w-3 h-3 rounded-full bg-secondary-light/15 dark:bg-secondary-dark/15 blur-md animate-float-slow" style={{ animationDelay: '2s', animationDuration: '6s' }}></div>
      
      {/* Diagonal subtle accent lines */}
      <div className="absolute -left-20 top-40 w-[500px] h-[1px] bg-gradient-to-r from-transparent via-primary-light/15 to-transparent rotate-[30deg]"></div>
      <div className="absolute -right-20 top-96 w-[500px] h-[1px] bg-gradient-to-r from-transparent via-secondary-light/15 to-transparent -rotate-[30deg]"></div>
    </div>
  );
} 